import PowerTrip from '../services/api/PowerTrip';
import axios from 'axios';
export default {
    methods: {
        login() {
          this.$router.push("/login");
        },
        signup() {
          this.$router.push("/new");
        },
        upload() {
          if (this.$user) {
            this.$user.trips = JSON.stringify(this.$trips);
            PowerTrip.saveUserData(this.$user, this.$auth);
          }
        },
        logout() {
          localStorage.removeItem("token");
          axios.defaults.headers.common["X-Auth-Powertrip"] = "";
          this.$router.go();
        },
      },  
}